/**
 * Service layer per i consensi newsletter lato USER (§11.9).
 *
 * Modello:
 *  - Seguite/consenso = relazione user_entities (entità da cui l'utente è raggiungibile).
 *  - Blocco          = riga in user_blocked_newsletter_entities (esclude anche se seguita).
 *  - Blocco globale  = allow_news.
 *
 * NB (DIP-3): la lista delle entità consentite (user_entities) è veicolata dentro la
 * risposta di GET /me/newsletter-preferences. Il nome esatto del campo è da confermare
 * col BE: il componente legge in modo difensivo (`entities` | `user_entities` | ...).
 *
 * Riferimento: TDD Sprint 18 §4.2 / §8.9.
 */
import API from '../../api';

export const preferencesApi = {
  /**
   * GET /me/newsletter-preferences
   * → { allow_news, blocked_entities: [{entity_id, name, created_at}], entities: [...] }
   */
  getMine: () => API.get('/me/newsletter-preferences'),

  /** PUT /me/newsletter-preferences — blocco globale. */
  setGlobal: (allowNews) => API.put('/me/newsletter-preferences', { allow_news: allowNews }),

  /** POST /me/newsletter-preferences/blocked-entities — blocca un'entità. */
  blockEntity: (entityId) => API.post('/me/newsletter-preferences/blocked-entities', { entity_id: entityId }),

  /** DELETE /me/newsletter-preferences/blocked-entities/{entityId} — sblocca (il BE crea una nota LOG). */
  unblockEntity: (entityId) => API.delete(`/me/newsletter-preferences/blocked-entities/${entityId}`),
};

/**
 * Estrae in modo difensivo la lista delle entità consentite (user_entities) dalla
 * risposta delle preferenze, gestendo i possibili nomi di campo (DIP-3).
 * Normalizza ogni elemento in un oggetto entità con almeno { id, name, entity_type }.
 */
export function extractConsentedEntities(data) {
  const raw = data?.entities ?? data?.user_entities ?? data?.consented_entities ?? data?.followed_entities ?? [];
  return raw.map((item) => {
    // L'elemento può essere già un'entità oppure una relazione { entity: {...} }.
    const entity = item.entity ?? item;
    return {
      id: entity.id ?? entity.entity_id ?? item.entity_id,
      name: entity.name,
      entity_type: entity.entity_type,
      raw: item,
    };
  });
}

/**
 * Estrae gli id delle entità bloccate dalla risposta delle preferenze.
 */
export function extractBlockedEntityIds(data) {
  return (data?.blocked_entities ?? []).map((b) => b.entity_id ?? b.id);
}

export default preferencesApi;
